import axios from 'axios'

// create an axios instance
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // 请求地址
	timeout: 10000, // 请求超时时间
})

//请求拦截器
service.interceptors.request.use(
	(config) => {
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

// 请求 响应
service.interceptors.response.use(
	(response) => {
		const res = response.data
		if (res.code !== 200) {
			return Promise.reject(res || 'Error')
		} else {
			return res.data
		}
	},
	(error) => {
	
		return Promise.reject(error || 'Error')
	}
)

export default service
